import type { SlashCommand } from './types';
import { buildNavCommands } from './navCommands';
import { buildUtilityCommands } from './utilityCommands';

export type { SlashCommand, CommandContext, MatchedCommand, SlashCommandGroup, LocalizedText } from './types';
export { recentCommandsStore } from './recentCommandsStore';
export { isDynamicGroup } from './types';
export { matchCommands } from './match';
export type { MatchInput } from './match';

/**
 * Build the full slash-command registry. Currently pure and static, but kept as a
 * function so future extensions (module-pluggable commands, feature flags) can
 * hook in without changing callers.
 */
export function buildCommandRegistry(): SlashCommand[] {
  return [...buildNavCommands(), ...buildUtilityCommands()];
}
